import React from 'react';
import { Input, Icon } from 'antd';
import cn from 'classnames';
import styles from './SearchField.module.scss';

const SearchField = ({ className, ...props }) => {
  return (
    <Input
      {...props}
      type="text"
      className={cn(styles.input, className)}
      suffix={<Icon type="search" />}
    />
  );
};

export default SearchField;
